import {useEffect} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {useLazyQuery} from '@apollo/client'
import {Button, Col, Row, Tab, Table, Tabs} from 'react-bootstrap'

import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {KTCard} from '../../../_metronic/helpers'
import {GET_ONE_DISPATCH} from '../../graphql/queries/getDespachos'
import {IResOneDispatch} from '../../graphql/types/despachoTypes'
import {Spinner} from '../../components/Spinner'
import {toast} from 'react-toastify'
import {parseId} from '../../helpers'
import moment from 'moment'
import {ViewDispatchBill} from '../../components/OneDispatch/ViewDispatchBill'
import {ViewDispatchDelivery} from '../../components/OneDispatch/ViewDispatchDelivery'
import Lottie from 'lottie-react'
import notFoundLottie from '../../assets/lotties/no-found.json'
import {useDisclosure} from '../../hooks/useDisclosure'
import {ModalCancelDispatch} from '../../components/OneDispatch/ModalCancelDispatch'
import {useGetUser} from '../../hooks/useGetUser'
import {ButtonPOS} from '../../components/OneDispatch/ButtonPOS'

export const OneDispatch = () => {
  const {user} = useGetUser()
  const {id} = useParams()
  const [gqlGetOneDispatch, {data, loading, error, refetch}] = useLazyQuery<IResOneDispatch>(
    GET_ONE_DISPATCH,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const navigate = useNavigate()

  const {isOpen, onClose, onOpen} = useDisclosure()

  useEffect(() => {
    if (!id || !Number(id)) {
      navigate('/despachos')
    }
    gqlGetOneDispatch({
      variables: {
        id,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (!error) return
    toast.error('Error: ' + error.message)
  }, [error])

  if (loading || !data) {
    return (
      <div>
        <BreadcrumbJeisat
          title='Descripción de despacho'
          breadcrumb={[
            {
              title: 'Despachos',
              path: '/despachos',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
          isBtns={false}
          children={undefined}
        />

        <div style={{height: '40vh'}} className='d-flex align-items-center justify-content-center'>
          <Spinner size='30px' />
        </div>
      </div>
    )
  }

  const dispatch = data.listDispatch.edges?.[0]?.node
  if (!dispatch) {
    return (
      <div>
        <BreadcrumbJeisat
          title='Detalle de despacho'
          breadcrumb={[
            {
              title: 'Despachos',
              path: '/despachos',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
          isBtns={false}
          children={undefined}
        />
        <div className='d-flex align-items-center justify-content-center' style={{height: '60vh'}}>
          <div className='d-flex align-items-center justify-content-around flex-column'>
            <h6>No se encontró despacho</h6>
            <div style={{maxWidth: '400px'}}>
              <Lottie animationData={notFoundLottie} />
            </div>
            <Link className='btn btn-info' to='/'>
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    )
  }

  const products = dispatch.dispatchproductthroughSet.edges

  /* const idDispatchSale = dispatch.sale.dispatchSet.edges.findIndex(
    ({node}) => node.id === dispatch.id */
  // const idDispatchSale = Number(dispatch.invoiceId)

  /* const idFact = `${
    parseId(dispatch.sale.id) < 10 ? `0${parseId(dispatch.sale.id)}` : parseId(dispatch.sale.id)
  }-${idDispatchSale < 9 ? `0${idDispatchSale}` : idDispatchSale}` */

  const idFact = `${dispatch.sale.invoiceId}`
  console.log('idFact', idFact)

  return (
    <div>
      <BreadcrumbJeisat
        title='Detalle de despacho'
        breadcrumb={[
          {
            title: 'Despachos',
            path: '/despachos',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <div>
            <div className='d-flex align-items-center gap-3 '>
              <Link
                to={`/venta/${parseId(dispatch.sale.id)}`}
                className='d-flex align-items-center gap-1'
                style={{textDecoration: 'underline'}}
              >
                <i className='las la-tags text-primary' />
                Ver venta
              </Link>
              <Button variant='danger' className='d-flex align-items-center gap-1' onClick={onOpen}>
                <i className='bi bi-exclamation-circle' style={{color: 'inherit'}} />
                Anular despacho
              </Button>
            </div>
          </div>
        }
      />
      <div className='p-6'>
        <Tabs className='nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto'>
          <Tab
            eventKey='Resumen'
            title={<span className='text-info'>Resumen</span>}
            color='primary'
          >
            <Row>
              <Col lg={8}>
                <KTCard className='mt-6 p-4'>
                  <h4>Información del despacho</h4>
                  <Table responsive bordered>
                    <tbody>
                      <tr>
                        <th>Placa</th>
                        <td className='text-uppercase'>{dispatch.plate}</td>
                      </tr>
                      <tr>
                        <th>Hora de salida</th>
                        <td>
                          {moment(dispatch.departureDatetime).format('DD MMM YYYY - hh:mm A')}
                        </td>
                      </tr>
                      <tr>
                        <th>Despachado por:</th>
                        <td>{dispatch.dispatchedBy}</td>
                      </tr>
                      <tr>
                        <th colSpan={2} className='text-center'>
                          Productos
                        </th>
                        {/* <td>{product.product.name}</td> */}
                      </tr>
                      {products.map(({node}, i) => (
                        <tr key={node.id}>
                          <th style={{verticalAlign: 'middle'}}>{node.product.name}</th>
                          <td>
                            <div>
                              <p>
                                <span className='fw-bold'>Cantidad: </span>
                                <span>{node.quantityDispatch}</span>
                              </p>
                              <p>
                                <span className='fw-bold'>Unidad: </span>
                                <span>{node.product.unitType}</span>
                              </p>
                              <p>
                                <span>
                                  {node.quantityDispatch} {node.product.unitType} de{' '}
                                  {node.product.name}
                                </span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </KTCard>

                <KTCard className='mt-4 p-4'>
                  <h5>Observaciones:</h5>
                  <p>{dispatch.observations || 'No registra'}</p>
                </KTCard>
              </Col>
              <Col lg={4}>
                <KTCard className='mt-6 p-4'>
                  <p>Usuario:</p>
                  <h4 className='text-uppercase'>
                    {dispatch.user.firstName} {dispatch.user.lastName}
                  </h4>
                </KTCard>
              </Col>
            </Row>
          </Tab>
          {Boolean(Number(user?.tokenAuth.settings.ENVELOPE)) && (
            <Tab
              eventKey='docs'
              title={<span className='text-info'>Documentos</span>}
              className='mt-4'
            >
              <KTCard className='mt-4 p-4'>
                <ViewDispatchBill dispatch={dispatch} idFact={idFact} />
              </KTCard>
            </Tab>
          )}

          {dispatch.delivery && Boolean(Number(user?.tokenAuth.settings.ENVELOPE)) && (
            <Tab
              eventKey='delivery'
              title={<span className='text-info'>Despacho</span>}
              className='mt-4'
            >
              <KTCard className='mt-4 p-4'>
                <ViewDispatchDelivery delivery={dispatch.delivery} id={dispatch.id} />
              </KTCard>
            </Tab>
          )}
        </Tabs>
      </div>

      {Boolean(Number(user?.tokenAuth.settings.POS)) && (
        <div className='d-flex flex-center'>
          <ButtonPOS dispatch={dispatch} idFact={idFact} />
        </div>
      )}

      <ModalCancelDispatch isOpen={isOpen} onClose={onClose} idDispatch={id!} refetch={refetch} />
    </div>
  )
}
